import {
  AbstractControl,
  ValidationErrors,
  ValidatorFn,
  Validators
} from '@angular/forms';
import { assign, isEmpty, omit } from 'lodash';

export function einSsnValidator(
  formGroup: AbstractControl<any>
): ValidationErrors | null {
  const einFormControl = formGroup.get('ein');
  const ssnFormControl = formGroup.get('ssn');

  const ein = einFormControl?.value;
  const ssn = ssnFormControl?.value;

  if (!ein && !ssn) {
    einFormControl?.setErrors(
      assign(einFormControl?.errors || {}, { ein: true })
    );
    ssnFormControl?.setErrors(
      assign(ssnFormControl?.errors || {}, { ssn: true })
    );

    return { ein: true, ssn: true };
  } else {
    const einFormControlErrors = omit(einFormControl?.errors, ['ein']);
    einFormControl?.setErrors(
      isEmpty(einFormControlErrors) ? null : einFormControlErrors
    );

    const ssnFormControlErrors = omit(ssnFormControl?.errors, ['ssn']);
    ssnFormControl?.setErrors(
      isEmpty(ssnFormControlErrors) ? null : ssnFormControlErrors
    );

    return null;
  }
}
